import clsx from 'clsx';

export default function CEUBadge({ hours, label = "CEUs Earned", size = "large", className }) {
  const sizeClasses = {
    small: "px-3 py-1.5",
    medium: "px-4 py-2",
    large: "px-6 py-3"
  };

  const textSizeClasses = {
    small: { label: "text-xs", value: "text-lg" },
    medium: { label: "text-sm", value: "text-xl" },
    large: { label: "text-sm", value: "text-2xl" }
  };

  return (
    <div className={clsx(
      "bg-primary text-white rounded-lg",
      sizeClasses[size],
      className
    )}>
      <div className={clsx("text-white/90", textSizeClasses[size].label)}>
        {label}
      </div>
      <div className={clsx("font-bold text-white", textSizeClasses[size].value)}>
        {hours || 0}
      </div>
    </div>
  );
}
